<template>
  <div class="blog-main-preview">
    <div class="image-wrapper">
      <img
        :alt="article.title"
        :src="getImageFromProxy(article.img || '', '600:400')"
        loading="eager"
      >
      <span class="top"><i class="i-fire mr2" /> TOP </span>
    </div>

    <div class="left-side">
      <p
        :style="{ color: article.category?.color }"
        class="category mb8"
      >
        {{ article.category?.title }}
      </p>
      <template v-if="isLangsEqual || isPostShowed">
        <h2>{{ article.title }}</h2>
        <p class="mb8 lh2 desc">
          {{ article.description }}
        </p>
        <nuxt-link
          :rel="!isLangsEqual ? 'nofollow' : ''"
          :to="localePath(`/blog/${article.category?.link}/${article.link}`)"
          class="btn btn-violet"
        >
          {{ $t('read_article') }}
        </nuxt-link>
      </template>
    </div>
    <LazyPagesBlogGradientPreview
      v-if="!isLangsEqual && !isPostShowed"
      :link="localePath(`/blog/${article.category?.link}/${article.link}`)"
      :title="article?.title || ''"
      rel="nofollow noindex"
      @show-card="isPostShowed = true"
    />
  </div>
</template>

<script lang="ts" setup>
import type { BlogPost } from '~/graphql/generated/schema-types';
import { languagesEnum } from '~/types/LocalesToCockies';

const props = defineProps<{ article: BlogPost }>();
const localePath = useLocalePath();
const { locale } = useI18n();
const isPostShowed = ref(false);

const isLangsEqual = computed(() => {
  return languagesEnum[locale.value.toUpperCase() as keyof typeof languagesEnum] === props.article?.lang || isPostShowed.value;
});
</script>

<style lang="scss" scoped>
.blog-main-preview {
  position: relative;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 48px;
  background: var(--surfaces-low-container);
  border-radius: 16px;

  .desc {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .image-wrapper {
    align-self: stretch;
    position: relative;
    overflow: hidden;
    max-width: 44%;
    width: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-height: 350px;
      border-radius: 16px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: bottom left;
    }

    .top {
      position: absolute;
      top: 12px;
      left: 12px;
    }
  }

  .left-side {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    text-align: left;
  }

  .top {
    color: var(--accent-on-primary);
    background: var(--accent-primary);
    border-radius: 10rem;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 8px;
  }

  .btn.btn-violet {
    display: inline-block;
    padding: 12px 24px;
  }

  @media screen and (max-width: 1250px) {
    gap: 20px;
  }
  @media screen and (max-width: 768px) {
    .image-wrapper img {
      max-height: 220px;
    }
  }
  @media screen and (max-width: 600px) {
    flex-direction: column;

    .image-wrapper {
      max-width: unset;

      img {
        max-height: 150px;
      }
    }
    .left-side {
      width: 100%;
      //text-align: center;
      //align-items: center;
      gap: 0;
    }
  }
}
</style>
